import { render } from "./HeroBackgroundAnimation.vue?vue&type=template&id=3775d60b&scoped=true"
const script = {}

import "./HeroBackgroundAnimation.vue?vue&type=style&index=0&id=3775d60b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3775d60b"]])

export default __exports__